import { useTranslation } from "@coworker/locales";
import { StoreTeam } from "@coworker/types/lib/storeteam";
import { BaseStepProps } from "../types";
import DeleteTeamConfirmationPrompt from "./components/DeleteTeamConfirmationPrompt";

type DeleteTeamConfirmationPromptStepProps = BaseStepProps & {
  visible: boolean;
  team: StoreTeam;
  isDeleting: boolean;
  onClose: () => void;
};

export const DeleteTeamConfirmationPromptStep = ({
  visible,
  team,
  isDeleting,
  onClose,
  goToNextStep,
}: DeleteTeamConfirmationPromptStepProps) => {
  const { t } = useTranslation();

  return (
    <DeleteTeamConfirmationPrompt
      t={t}
      selectedTeam={team}
      visible={visible}
      isDeleting={isDeleting}
      onClose={onClose}
      handleDelete={goToNextStep}
    />
  );
};
